import { jsx as _jsx } from "react/jsx-runtime";
import { FormSelect } from "../../../../../forms/inputs/select/index.js";
import useClassesInput from "./useClassesInput.js";
const SearcherFlightHotelClassesInput = ()=>{
    const classesInput = useClassesInput();
    return /*#__PURE__*/ _jsx(FormSelect, {
        ...classesInput
    });
};
export default SearcherFlightHotelClassesInput;

//# sourceMappingURL=index.js.map